var _slicedToArray = require("/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/slicedToArray.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var K = Object.create,
  f = Object.defineProperty,
  R = Object.getPrototypeOf,
  E = Object.prototype.hasOwnProperty,
  A = Object.getOwnPropertyNames,
  G = Object.getOwnPropertyDescriptor,
  I = Object.getOwnPropertySymbols,
  J = Object.prototype.propertyIsEnumerable;
var S = Object.assign,
  O = function O(e) {
    return f(e, "__esModule", {
      value: !0
    });
  };
var m = function m(e, n) {
  var l = {};
  for (var r in e) {
    E.call(e, r) && n.indexOf(r) < 0 && (l[r] = e[r]);
  }
  if (e != null && I) {
    var _iterator = _createForOfIteratorHelper(I(e)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        n.indexOf(r) < 0 && J.call(e, r) && (l[r] = e[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return l;
};
var L = function L(e, n) {
    for (var l in n) {
      f(e, l, {
        get: n[l],
        enumerable: !0
      });
    }
  },
  Q = function Q(e, n, l) {
    if (n && typeof n == "object" || typeof n == "function") {
      var _iterator2 = _createForOfIteratorHelper(A(n)),
        _step2;
      try {
        var _loop = function _loop() {
          var r = _step2.value;
          !E.call(e, r) && r !== "default" && f(e, r, {
            get: function get() {
              return n[r];
            },
            enumerable: !(l = G(n, r)) || l.enumerable
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return e;
  },
  P = function P(e) {
    return Q(O(f(e != null ? K(R(e)) : {}, "default", e && e.__esModule && "default" in e ? {
      get: function get() {
        return e.default;
      },
      enumerable: !0
    } : {
      value: e,
      enumerable: !0
    })), e);
  };
O(exports);
L(exports, {
  blockContentToPlainText: function blockContentToPlainText() {
    return Z;
  },
  default: function _default() {
    return X;
  }
});
var w = P(require("react")),
  t = P(require("prop-types")),
  s = P(require("@sanity/block-content-to-react")),
  z = s.default.defaultSerializers,
  q = function q(y) {
    var e = y.content,
      n = y.className,
      _y$serializers = y.serializers,
      l = _y$serializers === void 0 ? {} : _y$serializers,
      r = y.dataset,
      p = y.projectId,
      T = m(y, ["content", "className", "serializers", "dataset", "projectId"]);
    if (!e) throw new Error("No `content` provided to PortableText.");
    return w.default.createElement(s.default, S({
      blocks: e,
      className: n,
      serializers: V(l),
      renderContainerOnSingleChild: !0,
      dataset: r,
      projectId: p
    }, T));
  },
  X = q;
q.propTypes = {
  content: t.default.array.isRequired,
  className: t.default.string,
  projectId: t.default.string,
  dataset: t.default.string,
  ignoreUnknownTypes: t.default.bool,
  serializers: t.default.shape({
    link: t.default.elementType,
    strong: t.default.elementType,
    em: t.default.elementType,
    underline: t.default.elementType,
    del: t.default.elementType,
    code: t.default.elementType,
    ul: t.default.elementType,
    ol: t.default.elementType,
    li: t.default.elementType,
    h1: t.default.elementType,
    h2: t.default.elementType,
    h3: t.default.elementType,
    h4: t.default.elementType,
    h5: t.default.elementType,
    h6: t.default.elementType,
    blockquote: t.default.elementType,
    container: t.default.elementType,
    block: t.default.elementType,
    span: t.default.elementType,
    hardBreak: t.default.elementType,
    unknownType: t.default.elementType,
    unknownMark: t.default.elementType
  })
};
var V = function V(e) {
    var n = e.link,
      l = e.strong,
      r = e.em,
      p = e.underline,
      T = e.del,
      y = e.code,
      a = e.ul,
      B = e.ol,
      u = e.li,
      k = e.h1,
      h = e.h2,
      C = e.h3,
      N = e.h4,
      g = e.h5,
      j = e.h6,
      x = e.blockquote,
      _e$container = e.container,
      M = _e$container === void 0 ? "div" : _e$container,
      _e$block = e.block,
      U = _e$block === void 0 ? z.BlockSerializer : _e$block,
      _e$span = e.span,
      W = _e$span === void 0 ? z.SpanSerializer : _e$span,
      _e$hardBreak = e.hardBreak,
      $ = _e$hardBreak === void 0 ? z.HardBreakSerializer : _e$hardBreak,
      _e$unknownType = e.unknownType,
      D = _e$unknownType === void 0 ? z.DefaultUnknownTypeSerializer : _e$unknownType,
      _e$unknownMark = e.unknownMark,
      F = _e$unknownMark === void 0 ? "span" : _e$unknownMark,
      b = m(e, ["link", "strong", "em", "underline", "del", "code", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "container", "block", "span", "hardBreak", "unknownType", "unknownMark"]),
      _ = {
        h1: k,
        h2: h,
        h3: C,
        h4: N,
        h5: g,
        h6: j,
        blockquote: x
      };
    return {
      container: M,
      block: U,
      span: W,
      hardBreak: $,
      unknownType: D,
      unknownMark: F,
      marks: Y(S({
        link: n,
        strong: l,
        em: r,
        underline: p,
        code: y,
        "strike-through": T
      }, b)),
      list: function list(o) {
        var i = o.type,
          c = o.children,
          d = i === "bullet" ? a : B;
        return d ? d({
          children: c
        }) : s.default.defaultSerializers.list(o);
      },
      listItem: function listItem(o) {
        var i = o.children;
        return u ? u({
          children: i
        }) : s.default.defaultSerializers.listItem(o);
      },
      types: S({
        block: function block(o) {
          var i = o.node.style,
            c = o.children;
          return _[i] ? _[i]({
            children: c
          }) : b[i] ? b[i]({
            children: c
          }) : s.default.defaultSerializers.types.block(o);
        }
      }, Object.entries(b).reduce(function (o, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          i = _ref2[0],
          c = _ref2[1];
        var d = function d(_ref3) {
          var H = _ref3.node;
          return w.default.createElement(c, H);
        };
        return d.displayName = "".concat(v(i), "Wrapper"), o[i] = d, o;
      }, {}))
    };
  },
  Y = function Y(e) {
    return Object.entries(e).reduce(function (n, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        l = _ref5[0],
        r = _ref5[1];
      if (r) {
        var p = function p(h) {
          var T = h._type,
            y = h._key,
            a = h.mark,
            B = h.markKey,
            u = h.children,
            k = m(h, ["_type", "_key", "mark", "markKey", "children"]);
          if (typeof a == "object") {
            var C = a._type,
              N = a._key,
              g = m(a, ["_type", "_key"]);
            Object.entries(g).forEach(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 2),
                j = _ref7[0],
                x = _ref7[1];
              k[j] = x;
            });
          }
          return w.default.createElement(r, k, u);
        };
        p.displayName = "".concat(v(l), "Wrapper"), n[l] = p;
      }
      return n;
    }, {});
  },
  Z = function Z() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return e.map(function (n) {
      return n._type === "block" && n.children ? n.children.map(function (l) {
        return l.text;
      }).join("") : "";
    }).join("\n\n");
  },
  v = function v(e) {
    return e.slice(0, 1).toUpperCase() + e.slice(1);
  };